import React from "react";

interface Props {
  activeColor: string;
}

const LowIntentPercentageIcon = ({ activeColor }: Props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="20" fill="#F1F5F9" />

      <path
        d="M24 14L32 18V23C32 28 28.8 32.2 24 34C19.2 32.2 16 28 16 23V18L24 14Z"
        stroke="#64748B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LowIntentPercentageIcon;
